@use 'styles/functions/rem' as *;
@use 'styles/colors' as *;
@use 'styles/mixins/breakpoints' as *;

.highlight {
    bottom: rem(-2.5px);
    position: absolute;
}

.highlightTabs {
    display: flex;
    flex-direction: row;
    gap: rem(22px);
    justify-content: unset;
    margin: unset;
    position: relative;
    width: 100%;
}
